export const FILE_UPLOAD_SUCCESS_STATUS = 'success';
export const FILE_UPLOAD_ERROR_STATUS = 'error';
export const FILE_UPLOADING_STATUS = 'uploading';

export const FILE_UPLOADING_MESSAGE = 'Uploading';
export const FILE_UPLOAD_SUCCESS_MESSAGE = 'Upload successful';
export const FILE_UPLOAD_ERROR_MESSAGE = 'Upload failed';
export const FILE_TOO_LARGE_MESSAGE = 'File too large';
export const FILE_TOO_SMALL_MESSAGE = 'Image must be at least 512px x 512px';
